import _ from 'lodash';
import React, { Component } from 'react';
import moment from 'moment-timezone';

class IssueInformation extends Component {
  refundStatus = () => {
    return this.props.issue.refundStatus ?
      _.startCase(this.props.issue.refundStatus.replace(/_/g, ' ')) :
      'None';
  }

  renderIssueInfoRow(lhs, rhs) {
    return (
      <div className="row" style={{ marginLeft: 0 }}>
        <div style={{ width: 140 }}>
          <strong>{lhs}</strong>
        </div>
        <div>{rhs}</div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="issue-title mt-4 mb-4">{this.props.issue.issueType.shortName}</div>
        {this.renderIssueInfoRow('Teacher:', this.props.issue.teacher.name)}
        {this.renderIssueInfoRow('Student:', this.props.issue.reporter.name)}
        {this.renderIssueInfoRow('Service:', this.props.appointment.service.description)}
        {this.renderIssueInfoRow(
          'Time:',
          `${moment
            .utc(this.props.appointment.startTime)
            .local()
            .format('MMM DD, YYYY h:mma')} (Local - ${moment.tz.guess()})`
        )}
        {this.renderIssueInfoRow('Duration:', `${this.props.appointment.duration} minutes`)}
        {this.renderIssueInfoRow('Refund Status:', this.refundStatus())}
        {this.renderIssueInfoRow('Status:', this.props.appointment.status)}
        {this.renderIssueInfoRow('Appointment ID:', this.props.appointment.id)}
      </div>
    );
  }
}

export default IssueInformation;



// WEBPACK FOOTER //
// ./src/components/IssueInformation/index.js